import { z } from 'zod';
import { daysBetween, isCalendarDate } from '../../dates/calendar-date.js';
import { optionalUuidArray, requiredUuidString } from '../zod-helpers/index.js';
import { arBusinessDateInput } from './ar-business-date-input.js';
/** Spec §6.2: the window is capped at 5 years. */
export const CUSTOMER_AR_LEDGER_MAX_WINDOW_DAYS = 5 * 366;
/** The window length when the caller gives only `to`, or neither date. */
export const CUSTOMER_AR_LEDGER_DEFAULT_WINDOW_DAYS = 365;
export const customerArLedgerInputSchema = z
    .object({
    customerId: requiredUuidString('Customer is required.', 'Invalid customer selection.'),
    from: arBusinessDateInput.nullish(),
    to: arBusinessDateInput.nullish(),
    brandIds: optionalUuidArray('Invalid brand selection.').nullish(),
    includeCredits: z.boolean().nullish(),
})
    .superRefine(({ from, to }, context) => {
    // A missing bound is defaulted by the resolver; an invalid one has already failed its own check.
    if (!isCalendarDate(from) || !isCalendarDate(to))
        return;
    const days = daysBetween(from, to);
    if (days < 0) {
        context.addIssue({ code: 'custom', path: ['from'], message: 'From must not be after to.' });
    }
    else if (days > CUSTOMER_AR_LEDGER_MAX_WINDOW_DAYS) {
        context.addIssue({
            code: 'custom',
            path: ['from'],
            message: 'The window can span at most 5 years.',
        });
    }
});
//# sourceMappingURL=customer-ar-ledger-input.js.map